"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var material_1 = require("@angular/material");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var Observable_1 = require("rxjs/Observable");
var model_1 = require("./model");
var services_1 = require("./services");
var immutable_1 = require("immutable");
require("./hierarchical-search.component.scss");
var zip_1 = require("rxjs/observable/zip");
var abstract_destruction_subject_1 = require("../../abstract-destruction-subject");
var of_1 = require("rxjs/observable/of");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
/**
 * @author tatevik.marikyan
 * @since 29/06/2018
 */
var HierarchicalSearchComponent = /** @class */ (function (_super) {
    __extends(HierarchicalSearchComponent, _super);
    function HierarchicalSearchComponent(classifierService, kbService, messageService, searchService) {
        var _this = _super.call(this) || this;
        _this.classifierService = classifierService;
        _this.kbService = kbService;
        _this.messageService = messageService;
        _this.searchService = searchService;
        _this.validations = [];
        _this.valueChange = new core_1.EventEmitter();
        _this.validationEmitter = new core_1.EventEmitter();
        _this.searchCtrl = new forms_1.FormControl();
        _this.DEFAULT_ROWS_COUNT = 5;
        /**
         * Filtered Hierarchical search items' data
         * @type {any[]}
         * @private
         */
        _this.filteredData = [];
        /**
         * Load More Hierarchical Search Item
         * @type {HierarchicalSearchItem}
         * @private
         */
        _this.loadMoreEntity = new model_1.HierarchicalSearchItem('loadMore', immutable_1.Map());
        _this.onFilterValueChange();
        _this.rowsToShow = _this.DEFAULT_ROWS_COUNT;
        return _this;
    }
    HierarchicalSearchComponent.prototype.ngOnInit = function () {
        this.initHierarchicalSearchComponent();
    };
    HierarchicalSearchComponent.prototype.onEntitySelected = function (event) {
        if (event.source.selected) {
            this.selectedEntity = event.source.value;
            this.searchCtrl.setValue(event.source.value.displayName);
            this.rowsToShow = this.DEFAULT_ROWS_COUNT;
            this.bindSelectedValueToEntity(this.selectedEntity);
        }
    };
    HierarchicalSearchComponent.prototype.onLoadMoreSelected = function (event) {
        if (event.source.selected) {
            this.rowsToShow += this.DEFAULT_ROWS_COUNT;
            var displayName = this.searchCtrl.value instanceof model_1.HierarchicalSearchItem
                ? this.searchCtrl.value.displayName
                : this.searchCtrl.value;
            this.loadMoreEntity.displayName = displayName;
            this.searchCtrl.setValue(displayName, { emitEvent: true });
        }
    };
    /**
     * Indicates when to show "Load more" option
     * @returns {boolean}
     */
    HierarchicalSearchComponent.prototype.showLoadMoreOption = function () {
        return this.totalRows > this.rowsToShow;
    };
    /**
     * Indicates when to show "No More available items"
     * @returns {boolean}
     */
    HierarchicalSearchComponent.prototype.showNoDataAvailable = function () {
        return (!this.isEmptyValue() &&
            !this.selectedEntity &&
            this.filteredData.length === 0);
    };
    HierarchicalSearchComponent.prototype.isEmptyValue = function () {
        return (this.searchCtrl.value === undefined ||
            this.searchCtrl.value === null ||
            this.searchCtrl.value === '');
    };
    HierarchicalSearchComponent.prototype.clearSearchCtrl = function () {
        var _this = this;
        this.selectedEntity = null;
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.totalRows = 0;
        this.filteredData = [];
        this.searchCtrl.setValue('');
        this.valueChange.emit(null);
        this.selectedItemFields.forEach(function (itemField) {
            _this.entity.getProperty(itemField).value = null;
        });
    };
    HierarchicalSearchComponent.prototype.resetRowCount = function () {
        if (this.searchCtrl.value === '') {
            this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        }
    };
    HierarchicalSearchComponent.prototype.getValidationMsg = function () {
        var _this = this;
        if (!this.validations || this.validations.length === 0) {
            return of_1.of('');
        }
        var validationRelatedMetaFieldNames = this.validations
            .map(function (validation) {
            return validation
                .getRelatedMetaFieldIds()
                .map(function (relatedMetaFieldId) {
                return relatedMetaFieldId.getSystemName();
            });
        })
            .reduce(function (result, relatedMetaFieldNames) {
            return result.concat(relatedMetaFieldNames);
        });
        var validationMetaFieldNames = this.selectedItemFields
            .map(function (metaFieldName) {
            return validationRelatedMetaFieldNames.find(function (validationRelatedFieldName) {
                return validationRelatedFieldName === metaFieldName;
            });
        })
            .filter(function (validationMetaFieldName) {
            return validationMetaFieldName !== undefined &&
                validationMetaFieldName !== null;
        });
        if (validationMetaFieldNames.length > 0) {
            this.validationEmitter.emit();
        }
        return this.kbService.getMetaFields(this.entityCategorySystemName).pipe(operators_1.mergeMap(function (metaFields) {
            var messages$ = validationMetaFieldNames.map(function (metaFieldName) {
                return _this.messageService.getMessage(metaFields
                    .find(function (metaField) {
                    return metaField.getSystemName() === metaFieldName;
                })
                    .getDisplayNameMsgId());
            });
            var validationMainMsg = _this.messageService.getMessage('de_hierarchical_search_validation');
            messages$.push(validationMainMsg);
            return zip_1.zip.apply(void 0, messages$);
        }), operators_1.map(function (messages) {
            var validationMainMsg = messages.pop();
            return messages.length > 0
                ? validationMainMsg.replace('{0}', messages.join(', '))
                : '';
        }));
    };
    HierarchicalSearchComponent.prototype.trackByFunc = function (index, item) {
        if (item instanceof Observable_1.Observable) {
            return index;
        }
        return item.entityItem.id;
    };
    HierarchicalSearchComponent.prototype.initHierarchicalSearchComponent = function () {
        var _this = this;
        this.initRootCategorySystemName()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.initSelectedEntity();
        }, function (err) { return console.error(err); });
    };
    HierarchicalSearchComponent.prototype.initSelectedEntity = function () {
        var _this = this;
        var fieldValueMapping = immutable_1.Map();
        if (this.entity !== undefined && this.entity !== null) {
            var classifierNames$_1 = [];
            fieldValueMapping = fieldValueMapping.withMutations(function (mutable) {
                _this.categoryFieldsMapping.forEach(function (metaField, categoryName) {
                    var classifier = _this.entity.getProperty(metaField).value;
                    if (classifier !== null) {
                        classifierNames$_1.push(_this.classifierService.getEntityName(categoryName, classifier));
                        mutable.set(metaField, classifier.getId());
                    }
                });
            });
            zip_1.zip.apply(void 0, classifierNames$_1).pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (classifierNames) {
                classifierNames.reverse();
                _this.selectedEntity = new model_1.HierarchicalSearchItem(classifierNames.join(', '), fieldValueMapping, null);
                _this.searchCtrl.setValue(_this.selectedEntity.displayName);
            }, function (err) { return console.error(err); });
        }
    };
    HierarchicalSearchComponent.prototype.initRootCategorySystemName = function () {
        var _this = this;
        var firstMetaCategoryId = new idm_kb_service_client_js_1.MetaCategoryId(this.selectedItemCategories[this.selectedItemCategories.length - 1]);
        var ancestorsMetaCategoryIds = this.kbService.getAncestorsMetaCategoryIds(firstMetaCategoryId);
        return ancestorsMetaCategoryIds.pipe(operators_1.map(function (metaCategoryIds) {
            if (metaCategoryIds.length > 0) {
                _this.rootCategoryName = metaCategoryIds[metaCategoryIds.length - 1].getSystemName();
            }
            else {
                throw new Error('There is no root category');
            }
            return _this.rootCategoryName;
        }));
    };
    HierarchicalSearchComponent.prototype.onFilterValueChange = function () {
        var _this = this;
        this.filteredOptions = this.searchCtrl.valueChanges.pipe(operators_1.debounceTime(500), operators_1.mergeMap(function (value) {
            var searchValue = typeof value === 'string' ? value : value.displayName;
            return value === '' || value === null
                ? of_1.of(new idm_de_service_client_js_1.ServiceResponseDefault())
                : _this.searchEntities(searchValue);
        }), operators_1.map(function (serviceResponse) {
            _this.totalRows =
                serviceResponse.getMeta() !== undefined
                    ? serviceResponse.getMeta().getTotalRowCount()
                    : 0;
            if (!_this.autoComplete.autocomplete._isOpen &&
                !_this.selectedEntity) {
                _this.autoComplete.openPanel();
            }
            _this.filteredData =
                serviceResponse.getData() !== undefined
                    ? serviceResponse.getData()
                    : [];
            return _this.filteredData;
        }));
    };
    HierarchicalSearchComponent.prototype.searchEntities = function (query) {
        var filter = new model_1.HierarchicalSearchFilterOptions(query, this.selectedItemCategories, this.currentLanguageId);
        var paging = new idm_de_core_frontend_1.PagingOptions(0, this.rowsToShow);
        return this.searchService.loadHierarchicalEntities(this.categoryFieldsMapping, this.rootCategoryName, filter, paging);
    };
    HierarchicalSearchComponent.prototype.bindSelectedValueToEntity = function (selectedEntity) {
        var _this = this;
        var category;
        var hasMatch = false;
        // resetting Main Entity old Values
        this.categoryFieldsMapping.forEach(function (metaFieldName) {
            _this.entity.getProperty(metaFieldName).value = null;
        });
        var lastLevelClassifierData = null;
        selectedEntity.fieldValueMapping.forEach(function (classifierId, metaFieldName) {
            hasMatch = false;
            _this.categoryFieldsMapping.forEach(function (metaField, categoryName) {
                if (!hasMatch && metaField === metaFieldName) {
                    category = categoryName;
                    hasMatch = true;
                }
            });
            if (!hasMatch) {
                throw new Error("No Category Name mapping for " + metaFieldName + " Meta Field name.");
            }
            lastLevelClassifierData = {
                categoryName: category,
                metaFieldName: metaFieldName,
                value: classifierId,
            };
            _this.classifierService
                .loadClassifier(category, classifierId)
                .pipe(operators_1.takeUntil(_this.destroySubject$))
                .subscribe(function (classifier) {
                _this.entity.getProperty(metaFieldName).value = classifier;
            }, function (err) { return console.error(err); });
        });
        this.valueChange.emit(lastLevelClassifierData);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSearchComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalSearchComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HierarchicalSearchComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalSearchComponent.prototype, "validations", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSearchComponent.prototype, "entityCategorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalSearchComponent.prototype, "selectedItemCategories", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalSearchComponent.prototype, "selectedItemFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalSearchComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], HierarchicalSearchComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HierarchicalSearchComponent.prototype, "validationEmitter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HierarchicalSearchComponent.prototype, "categoryFieldsMapping", void 0);
    __decorate([
        core_1.ViewChild('autoCompleteInput', { read: material_1.MatAutocompleteTrigger }),
        __metadata("design:type", material_1.MatAutocompleteTrigger)
    ], HierarchicalSearchComponent.prototype, "autoComplete", void 0);
    HierarchicalSearchComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'hierarchical-search',
            template: require('./hierarchical-search.component.html'),
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.MessageService,
            services_1.HierarchicalSearchService])
    ], HierarchicalSearchComponent);
    return HierarchicalSearchComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HierarchicalSearchComponent = HierarchicalSearchComponent;
//# sourceMappingURL=hierarchical-search.component.js.map